import React from 'react'
import styled from '@emotion/styled'

const TOCWrapper = styled.div`
	margin-right: 2em;
	border: 1px solid ${({ theme }) => theme.colors.borderMedium};
	list-style-type: none;
	padding: 1em;

	${({ theme }) => theme.MQ.M} {
		float: left;
	}

	${({ theme }) => theme.MQ.L} {
		margin-left: ${({ theme }) => `${(theme.BREAKPOINTS['M'] - theme.BREAKPOINTS['L']) / 2}`}px;
	}

	h4 {
		margin-top: 0;
		margin-bottom: 0.5em;
	}
`

export const SimpleTOC = ({ contentList }) => {
	return (
		<TOCWrapper>
			<h4>Table of Contents</h4>
			<li>
				{contentList.map(({ name, slug }, i) => (
					<li key={`${i}-${slug}`}>
						<a href={`${slug}`}>{name}</a>
					</li>
				))}
			</li>
		</TOCWrapper>
	)
}

SimpleTOC.defaultProps = {
	contentList: [
		{ name: 'Information We Collect', slug: '#information-we-collect' },
		{ name: 'How We Use Your Information', slug: '#how-we-use-your-info' },
		{ name: 'When We Disclose Your Information', slug: '#when-we-disclose-your-information' },
		{ name: 'Legal Basis for Processing Personal Data', slug: '#legal-basis-for-processing-personal-data' },
		{ name: 'Personalized Consent and Advertising', slug: '#personalized-consent-advertising' },
		{ name: 'Your Rights and Choices', slug: '#your-rights-and-choices' },
		{ name: 'Security', slug: '#security' },
		{ name: 'Data Retention', slug: '#data-retention' },
		{ name: 'International Users', slug: '#international-users' },
		{ name: 'Third Party Links and Services', slug: '#third-party-links-and-services' },
		{ name: 'Your California Privacy Rights', slug: '#your-california-privacy-rights' },
		{ name: 'Information from Children', slug: '#information-from-children' },
		{ name: 'Changes to this Policy', slug: '#changes-to-this-policy' },
		{ name: 'Contact Us', slug: '#questions-about-this-policy' },
	],
}
